import { render, staticRenderFns } from "./finishFormula.vue?vue&type=template&id=4c040886&scoped=true&"
import script from "./finishFormula.vue?vue&type=script&lang=js&"
export * from "./finishFormula.vue?vue&type=script&lang=js&"
import style0 from "./finishFormula.vue?vue&type=style&index=0&id=4c040886&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c040886",
  null
  
)

export default component.exports